import { memo } from 'react';
import { WithdrawTemplate } from 'components/templates/WithdrawTemplate';

type Props = {};

export const WithdrawPage = memo((_props: Props) => {
	return <WithdrawTemplate />;
});
